'use strict';

/**
 * StripeError is the base error from which all other more specific Stripe errors derive.
 * Specifically for errors returned from Stripe's REST API.
 */
var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var StripeError = /*#__PURE__*/function (_Error) {
  _inherits(StripeError, _Error);
  function StripeError() {
    var _this;
    var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, StripeError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StripeError).call(this, raw.message));
    _this.type = _this.constructor.name;
    _this.raw = raw;
    _this.rawType = raw.type;
    _this.code = raw.code;
    _this.doc_url = raw.doc_url;
    _this.param = raw.param;
    _this.detail = raw.detail;
    _this.headers = raw.headers;
    _this.requestId = raw.requestId;
    _this.statusCode = raw.statusCode;
    _this.message = raw.message;
    _this.charge = raw.charge;
    _this.decline_code = raw.decline_code;
    _this.payment_intent = raw.payment_intent;
    _this.payment_method = raw.payment_method;
    _this.payment_method_type = raw.payment_method_type;
    _this.setup_intent = raw.setup_intent;
    _this.source = raw.source;
    return _this;
  }

  /**
   * Helper factory which takes raw stripe errors and outputs wrapping instances
   */
  _createClass(StripeError, null, [{
    key: "generate",
    value: function generate(rawStripeError) {
      switch (rawStripeError.type) {
        case 'card_error':
          return new StripeCardError(rawStripeError);
        case 'invalid_request_error':
          return new StripeInvalidRequestError(rawStripeError);
        case 'api_error':
          return new StripeAPIError(rawStripeError);
        case 'authentication_error':
          return new StripeAuthenticationError(rawStripeError);
        case 'rate_limit_error':
          return new StripeRateLimitError(rawStripeError);
        case 'idempotency_error':
          return new StripeIdempotencyError(rawStripeError);
        case 'invalid_grant':
          return new StripeInvalidGrantError(rawStripeError);
        default:
          return new StripeUnknownError(rawStripeError);
      }
    }
  }]);
  return StripeError;
}(_wrapNativeSuper(Error)); // Specific Stripe Error types:
/**
 * CardError is raised when a user enters a card that can't be charged for
 * some reason.
 */
var StripeCardError = /*#__PURE__*/function (_StripeError) {
  _inherits(StripeCardError, _StripeError);
  function StripeCardError() {
    _classCallCheck(this, StripeCardError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeCardError).apply(this, arguments));
  }
  return StripeCardError;
}(StripeError);
/**
 * InvalidRequestError is raised when a request is initiated with invalid
 * parameters.
 */
var StripeInvalidRequestError = /*#__PURE__*/function (_StripeError2) {
  _inherits(StripeInvalidRequestError, _StripeError2);
  function StripeInvalidRequestError() {
    _classCallCheck(this, StripeInvalidRequestError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeInvalidRequestError).apply(this, arguments));
  }
  return StripeInvalidRequestError;
}(StripeError);
/**
 * APIError is a generic error that may be raised in cases where none of the
 * other named errors cover the problem. It could also be raised in the case
 * that a new error has been introduced in the API, but this version of the
 * Node.JS SDK doesn't know how to handle it.
 */
var StripeAPIError = /*#__PURE__*/function (_StripeError3) {
  _inherits(StripeAPIError, _StripeError3);
  function StripeAPIError() {
    _classCallCheck(this, StripeAPIError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeAPIError).apply(this, arguments));
  }
  return StripeAPIError;
}(StripeError);
/**
 * AuthenticationError is raised when invalid credentials are used to connect
 * to Stripe's servers.
 */
var StripeAuthenticationError = /*#__PURE__*/function (_StripeError4) {
  _inherits(StripeAuthenticationError, _StripeError4);
  function StripeAuthenticationError() {
    _classCallCheck(this, StripeAuthenticationError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeAuthenticationError).apply(this, arguments));
  }
  return StripeAuthenticationError;
}(StripeError);
/**
 * PermissionError is raised in cases where access was attempted on a resource
 * that wasn't allowed.
 */
var StripePermissionError = /*#__PURE__*/function (_StripeError5) {
  _inherits(StripePermissionError, _StripeError5);
  function StripePermissionError() {
    _classCallCheck(this, StripePermissionError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripePermissionError).apply(this, arguments));
  }
  return StripePermissionError;
}(StripeError);
/**
 * RateLimitError is raised in cases where an account is putting too much load
 * on Stripe's API servers (usually by performing too many requests). Please
 * back off on request rate.
 */
var StripeRateLimitError = /*#__PURE__*/function (_StripeError6) {
  _inherits(StripeRateLimitError, _StripeError6);
  function StripeRateLimitError() {
    _classCallCheck(this, StripeRateLimitError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeRateLimitError).apply(this, arguments));
  }
  return StripeRateLimitError;
}(StripeError);
/**
 * StripeConnectionError is raised in the event that the SDK can't connect to
 * Stripe's servers. That can be for a variety of different reasons from a
 * downed network to a bad TLS certificate.
 */
var StripeConnectionError = /*#__PURE__*/function (_StripeError7) {
  _inherits(StripeConnectionError, _StripeError7);
  function StripeConnectionError() {
    _classCallCheck(this, StripeConnectionError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeConnectionError).apply(this, arguments));
  }
  return StripeConnectionError;
}(StripeError);
/**
 * SignatureVerificationError is raised when the signature verification for a
 * webhook fails
 */
var StripeSignatureVerificationError = /*#__PURE__*/function (_StripeError8) {
  _inherits(StripeSignatureVerificationError, _StripeError8);
  function StripeSignatureVerificationError() {
    _classCallCheck(this, StripeSignatureVerificationError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeSignatureVerificationError).apply(this, arguments));
  }
  return StripeSignatureVerificationError;
}(StripeError);
/**
 * IdempotencyError is raised in cases where an idempotency key was used
 * improperly.
 */
var StripeIdempotencyError = /*#__PURE__*/function (_StripeError9) {
  _inherits(StripeIdempotencyError, _StripeError9);
  function StripeIdempotencyError() {
    _classCallCheck(this, StripeIdempotencyError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeIdempotencyError).apply(this, arguments));
  }
  return StripeIdempotencyError;
}(StripeError);
/**
 * InvalidGrantError is raised when a specified code doesn't exist, is
 * expired, has been used, or doesn't belong to you; a refresh token doesn't
 * exist, or doesn't belong to you; or if an API key's mode (live or test)
 * doesn't match the mode of a code or refresh token.
 */
var StripeInvalidGrantError = /*#__PURE__*/function (_StripeError10) {
  _inherits(StripeInvalidGrantError, _StripeError10);
  function StripeInvalidGrantError() {
    _classCallCheck(this, StripeInvalidGrantError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeInvalidGrantError).apply(this, arguments));
  }
  return StripeInvalidGrantError;
}(StripeError);
/**
 * Any other error from Stripe not specifically captured above
 */
var StripeUnknownError = /*#__PURE__*/function (_StripeError11) {
  _inherits(StripeUnknownError, _StripeError11);
  function StripeUnknownError() {
    _classCallCheck(this, StripeUnknownError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StripeUnknownError).apply(this, arguments));
  }
  return StripeUnknownError;
}(StripeError);
module.exports.generate = StripeError.generate;
module.exports.StripeError = StripeError;
module.exports.StripeCardError = StripeCardError;
module.exports.StripeInvalidRequestError = StripeInvalidRequestError;
module.exports.StripeAPIError = StripeAPIError;
module.exports.StripeAuthenticationError = StripeAuthenticationError;
module.exports.StripePermissionError = StripePermissionError;
module.exports.StripeRateLimitError = StripeRateLimitError;
module.exports.StripeConnectionError = StripeConnectionError;
module.exports.StripeSignatureVerificationError = StripeSignatureVerificationError;
module.exports.StripeIdempotencyError = StripeIdempotencyError;
module.exports.StripeInvalidGrantError = StripeInvalidGrantError;
module.exports.StripeUnknownError = StripeUnknownError;